import { useAppDispatch } from '@verantos-dev/app-state-base';
import { resetCohortBuilderSlice } from '@verantos-dev/app-state-cohort-builder';
import { resetCohortDefinitionLegacy } from '@verantos-dev/app-state-cohort-definition';
import { resetResearchAssistantState } from '@verantos-dev/app-state-research-assistant';

export const useResetCohortBuilderState = () => {
  const dispatch = useAppDispatch();

  const resetCohortBuilderState = () => {
    dispatch(resetCohortBuilderSlice());
    dispatch(resetCohortDefinitionLegacy());
    dispatch(resetResearchAssistantState());
  };

  return { resetCohortBuilderState };
};
